"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteCookie = deleteCookie;
exports.getCookie = getCookie;
exports.setCookie = setCookie;
/*
 * Cookie util functions sourced from:
 * https://plainjs.com/javascript/utilities/set-cookie-get-cookie-and-delete-cookie-5/
 */

function getCookie(name) {
  let v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
  return v ? v[2] : null;
}
function setCookie(name, value, days, domain) {
  let d = new Date();
  d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);
  let cookieStr = name + "=" + value + (domain ? ';domain=' + domain : '') + ";path=/;expires=" + d.toGMTString();
  document.cookie = cookieStr;
}
function deleteCookie(name) {
  setCookie(name, '', -1);
}